import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DisclaimerModal from './components/DisclaimerModal/DisclaimerModal';
import HomePage from './pages/homepage/HomePage';
import ServicesPage from './pages/services/ServicesPage';
import BlogPage from './pages/blogpage/BlogPage';
import ContactPage from './pages/contactpage/ContactPage';
import AboutUs from './pages/aboutus/AboutUs';
import PostPage from './pages/postpage/PostPage';
import FAQPage from './pages/faqpage/FAQPage';
import DisclaimerPage from './pages/legal/DisclaimerPage';
import PrivacyPolicyPage from './pages/legal/PrivacyPolicyPage';
import './App.css';

import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <DisclaimerModal />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<Navigate to="/services/civil-law" replace />} />
          <Route path="/services/:serviceId" element={<ServicesPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:id" element={<PostPage />} />
          <Route path="/faqs" element={<FAQPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
